import React, { useEffect, useState } from "react";

import PhotoAndTeam from "./components/PhotoAndTeam";
import { countryCodes, userRegistration } from "../../services/MainApiDetails";
import { Link } from "react-router-dom";
import { ERROR, PRIMARY } from "../../utilities/colors";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIcon from '@mui/icons-material/PhoneOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import "./mobileRegister.css";
const MobileRegisterForm = ({ onSwitchTab }) => {
  const [signupStep, setSignupStep] = useState(localStorage.webKey ? 2 : 1);
  const [countryCode, setCountryCode] = useState("");
  const [defaultDialCode, setDefaultDialCode] = useState("+91");
  const [countryCodeObj, setCountryCodeObj] = useState("");

  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [confirmUserPassword, setConfirmUserPassword] = useState("");
  const [passText, setPassText] = useState("");
  const [confirmPassText, setConfirmPassText] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [error, setError] = useState("");
  const [errors, setErrors] = useState({
    phone: "",
    email: "",
    name: "",
  });

  useEffect(() => {
    getCountryCodes();
  }, []);

  function getCountryCodes() {
    countryCodes({})
      .then((res) => {
        if (res.data.status === 1) {
          setCountryCode(res.data.result);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  function countryCodeFunction(item) {
    let cCode = countryCode.filter((single) => single.dial_code === item);
    setDefaultDialCode(cCode[0].dial_code);

    setCountryCodeObj(cCode);
  }

  function validatePhone() {
    var validation = false;

    let regex = /^[0-9]$/;
    validation = regex.test(userPhone);

    return validation;
  }

  function validateEmail() {
    var validation = false;

    let regex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
    validation = regex.test(userEmail.trim());

    return validation;
  }

  function passwordFunc(e) {
    let val = e.target.value;
    setUserPassword(val);
    setPassText(val);
  }

  function confirmPasswordFunc(e) {
    let val = e.target.value;

    if (userPassword === val) {
      setConfirmPassText("Matched");
    } else {
      setConfirmPassText("Password do not match");
    }

    setConfirmUserPassword(val);
  }

  function RegisterUser(e) {
    e.preventDefault();

    var message = [];

    var flag = 0;

    if (
      userPhone === "" ||
      userPhone.length < 8 ||
      userPhone.length > 12
    ) {
      message.phone = "Invalid phone number";
      setErrors(message);
      flag = 1;
    } else if (defaultDialCode == "+91" && userPhone.length != 10) {

      message.phone = "Invalid phone number";
      setErrors(message);
      flag = 1;
    } else {
      let phoneNum = defaultDialCode + userPhone;
      message.phone = "";
      setErrors(message);
    }
    if (userEmail && !validateEmail()) {
      message.email = "Invalid email address";
      setErrors(message);
      flag = 1;
    } else {
      let email = userEmail;
      message.email = "";
      setErrors(message);
    }

    if (userPassword !== confirmUserPassword) {
      message.password = "Password do not match";
      setErrors(message);
      flag = 1;
    } else if (userPassword < 6) {
      message.password = "Password is too short";
      setErrors(message);
      flag = 1;
    } else {
      let password = userPassword;
      message.password = "";
      setErrors(message);
    }

    if (flag == 0) {
      setLoading(true)
      let phoneNum = defaultDialCode + userPhone;
      let code = defaultDialCode.split("+");
      let data;
      data = {
        name: userName,
        phone: userPhone,
        country_code: code[1],
        email: userEmail,
        password: userPassword,
      };

      userRegistration(data)
        .then((response) => {
          setLoading(false)

          if (response.data.status === 1) {
            localStorage.setItem("webKey", response.data.web_token);
            setSignupStep(2);
          } else {
            setError(response.data.message);
          }
        })
        .catch((err, message) => {
          console.log(err + message);
        });
    }
  }

  function RegisterSteps() {
    switch (signupStep) {
      case 1:
        return (
          <div className="mobileRegister-form-bottom">
            <form action="">
              <div className="mobileRegister-input-wrapper">
                <div className="mobileRegister-inputBox">
                  <span>Name</span>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder="Type here"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      style={{ width: '100%', paddingRight: '40px' }}
                    />
                    <span style={{
                      position: 'absolute', right: '10px', display: 'flex',
                      alignItems: 'center', justifyContent: 'center', height: '100%', top: 0,
                    }}>
                      <PersonOutlineIcon fontSize="small" />
                    </span>
                  </div>
                </div>
                <div className="mobileRegister-inputBox">
                  <span>Mobile Number</span>
                  <div className="mobileRegister-phoneInput-container">
                    <select
                      onChange={(e) => countryCodeFunction(e.target.value)}
                      name="country-code"
                      id="country-code"
                    >
                      {countryCode
                        ? countryCode.map((item) => (
                          <option
                            key={item._id}
                            value={item.dial_code}
                            selected={
                              item.dial_code == defaultDialCode
                                ? "selected"
                                : ""
                            }
                          >
                            {item.dial_code}
                          </option>
                        ))
                        : ""}
                    </select>
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '80%' }}>
                      <input
                        type="number"
                        placeholder="Type here"
                        value={userPhone}
                        onChange={(e) => setUserPhone(e.target.value)}
                        style={{ width: '100%', paddingRight: '40px' }}
                      />
                      <span style={{
                        position: 'absolute', right: '10px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', height: '100%', top: 0,
                      }}>
                        <PhoneIcon fontSize="small" />
                      </span>
                    </div>
                  </div>

                  <span className="mandatory-text">
                    You can't change mobile number in future
                  </span>
                  <span style={{ color: ERROR }}>{errors.phone}</span>
                </div>
                <div className="mobileRegister-inputBox">
                  <span>Email ID</span>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="text"
                      placeholder="Type here"
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                      style={{ width: '100%', paddingRight: '40px' }}
                    />
                    <span style={{
                      position: 'absolute', right: '10px', display: 'flex',
                      alignItems: 'center', justifyContent: 'center', height: '100%', top: 0,
                    }}>
                      <EmailIcon fontSize="small" />
                    </span>
                  </div>
                  <span className="mandatory-text">
                    You can't change email id in future
                  </span>
                  <span style={{ color: ERROR }}>{errors.email}</span>
                </div>
                <div className="mobileRegister-inputBox">
                  <span>Enter Password</span>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Type here"
                      value={userPassword}
                      onChange={passwordFunc}
                      style={{ width: '100%', paddingRight: '40px' }}
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        top: 0,
                      }}>
                      {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                    </span>
                  </div>
                  {userPassword.length > 6 ? (
                    <span>Strong Password</span>
                  ) : (
                    <span>Minimum 6 characters</span>
                  )}
                  <span style={{ color: ERROR }}>{errors.password}</span>
                </div>
                <div className="mobileRegister-inputBox">
                  <span>Confirm Password</span>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder="Type here"
                      value={confirmUserPassword}
                      onChange={confirmPasswordFunc}
                      style={{ width: '100%', paddingRight: '40px' }}
                    />
                    <span
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        top: 0,
                      }}>
                      {showConfirmPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                    </span>
                  </div>
                  <span>{confirmPassText}</span>
                </div>
              </div>
              <span style={{ color: ERROR }}>{error}</span>

              <div className="mobileRegister-terms-text">
                <p>By clicking sign up you agree to</p>
                <p>
                  <Link to="/mobile-terms-conditions" style={{ color: PRIMARY }}>our terms and conditions.</Link>
                </p>
              </div>
              <div className="mobileRegister-signup-button">
                <button onClick={(e) => RegisterUser(e)}> {loading && (
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}SIGNUP</button>
              </div>
            </form>
           <div className="mobileRegister-bottom-content">
  <p className="login-text">Already have an account?</p>
  <p className="login-btn" onClick={onSwitchTab} style={{ cursor: "pointer" }}>
    Login
  </p>
</div>
          </div>
        );
      case 2:
        return <PhotoAndTeam />;
      default:
        return null;
    }
  }

  return (
    <>
      <div className="mobileRegister-form-top">
        <p>Save and track your predictions </p>
      </div>
      {RegisterSteps()}
    </>
  );
};

export default MobileRegisterForm;